import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#4A3A2A] text-white py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold font-poppins mb-4">Contact</h4>
            <div className="space-y-3">
              <a
                href="mailto:christophe.marrama@croissanceconsulting.net"
                className="flex items-start space-x-3 text-white/80 hover:text-white transition-colors break-all"
              >
                <Mail size={20} className="flex-shrink-0 mt-1" />
                <span className="text-sm">christophe.marrama@croissanceconsulting.net</span>
              </a>
              <a
                href="tel:+33674245563"
                className="flex items-center space-x-3 text-white/80 hover:text-white transition-colors"
              >
                <Phone size={20} className="flex-shrink-0" />
                <span>06 74 24 55 63</span>
              </a>
              <div className="flex items-center space-x-3 text-white/80">
                <span className="text-sm">Site : croissanceconsulting.net</span>
              </div>
            </div>
          </div>

          {/* Liens rapides */}
          <div>
            <h4 className="text-lg font-semibold font-poppins mb-4">Liens rapides</h4>
            <div className="space-y-2">
              <Link
                to="/offres"
                className="block text-white/80 hover:text-white transition-colors text-sm"
              >
                Nos offres
              </Link>
              <Link
                to="/stop-aux-invendus"
                className="block text-white/80 hover:text-white transition-colors text-sm"
              >
                Stop aux invendus
              </Link>
              <Link
                to="/audit-rentabilite-boulangerie"
                className="block text-white/80 hover:text-white transition-colors text-sm"
              >
                Diagnostic immersion
              </Link>
              <Link
                to="/blog"
                className="block text-white/80 hover:text-white transition-colors text-sm"
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className="block text-white/80 hover:text-white transition-colors text-sm"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-lg font-semibold font-poppins mb-4">Réseaux sociaux</h4>
            <div className="flex space-x-4">
              <a
                href="https://www.threads.com/@christophemarrama?xmt=AQF0LV9B_1fOGLWGucuOURdnx2XDaLb-AU9XBKZItt1r-3E"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                aria-label="Instagram Threads"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.linkedin.com/in/marrama-christophe-91485a311"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Croissance 🥐consulting. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
